import { FormikProvider, useFormik } from 'formik'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { Container, Form, TabContent, TabPane } from 'reactstrap'
import * as Yup from 'yup'
import contacts from '../../api/contacts/hooks'
import { ContactType } from '../../api/globalTypes'
import FormActionButtons from '../../Components/Common/FormActionButtons'
import PageTitle from '../../Components/Common/PageTitle'
import ContactFormGeneralTab, {
    ContactFormGeneralTabMain,
    ContactFormGeneralTabSide,
} from '../../Components/ContactFormGeneralTab/ContactFormGeneralTab'
import { useFormValidationErrorModal } from '../../Components/Modals/FormValidationErrorModal/useFormValidationErrorModal'
import { contactFormTabs } from './constants'
import { useContactGeneralFormConfig } from './hooks'

const ContactCreate = () => {
    const history = useHistory()
    const { t } = useTranslation()

    const tabs = contactFormTabs(false)
    const [activeTab, setActiveTab] = useState(tabs[0]?.name)

    const { generalInputs, generalValidationConfig } = useContactGeneralFormConfig(null, ContactType.Person)

    const { mutate: createContact, isPending } = contacts.CreateUpdateContact.useMutation()

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            general: generalValidationConfig.initialValues ?? {},
        },
        validationSchema: Yup.object({
            general: generalValidationConfig.validationSchema ?? Yup.object({}),
        }),
        onSubmit: (values) => {
            const submitValues = {
                ...generalValidationConfig.prepareModelForSubmit(values.general),
                contact_type: ContactType.Person,
            }

            delete submitValues.id

            createContact({ data: submitValues, isEdit: false, contactType: ContactType.Person })
        },
    })

    useFormValidationErrorModal(formik, [generalInputs])

    const handleTabChange = (tab: string) => {
        if (activeTab !== tab) {
            setActiveTab(tab)
        }
    }

    const renderFormButtons = () => <FormActionButtons disabled={isPending} hasCancel={true} cancelAction={() => history.push('/contacts')} />

    return (
        <div className="page-content">
            <Container fluid>
                <FormikProvider value={formik}>
                    <Form onSubmit={(e) => formik.handleSubmit(e)}>
                        <PageTitle title={t('page.newContact')}>{renderFormButtons()}</PageTitle>

                        <TabContent activeTab={activeTab} className="text-muted">
                            <TabPane tabId="general">
                                <ContactFormGeneralTab
                                    subform="general"
                                    tabs={tabs}
                                    activeTab={activeTab}
                                    inputs={generalInputs}
                                    formik={formik}
                                    contactType={ContactType.Person}
                                    handleTabChange={handleTabChange}
                                >
                                    <ContactFormGeneralTabSide />
                                    <ContactFormGeneralTabMain />
                                </ContactFormGeneralTab>
                            </TabPane>
                        </TabContent>
                    </Form>
                </FormikProvider>
            </Container>
        </div>
    )
}

export default ContactCreate
